import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SvgComponent() {
    return (_jsxs("svg", { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "prefix__feather prefix__feather-search", children: [_jsx("circle", { cx: 11, cy: 11, r: 8 }), _jsx("path", { d: "M21 21l-4.35-4.35" })] }));
}
export default SvgComponent;
